export const centsFormat = (number) => {
    try {
        const result = (number / 100).toFixed(2);
        const parts = result.split('.');
        parts[1] = parts[1].padEnd(2, '0');
        return parts.join('.');
    }
    catch (error) {
        return '0.0';
    }
};
export const tryToGetUserDataLayer = () => {
    var _a, _b, _c, _d, _e;
    try {
        const userDatabase = JSON.parse(localStorage.getItem('user-database'));
        if (userDatabase) {
            return {
                userId: (_a = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.user) === null || _a === void 0 ? void 0 : _a.id,
                userRole: (_c = (_b = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.user) === null || _b === void 0 ? void 0 : _b.role) === null || _c === void 0 ? void 0 : _c.description,
                userStatus: (_e = (_d = userDatabase === null || userDatabase === void 0 ? void 0 : userDatabase.user) === null || _d === void 0 ? void 0 : _d.status) === null || _e === void 0 ? void 0 : _e.description
            };
        }
        return {};
    }
    catch (error) {
        return {};
    }
};
